import { FC } from "react";
import { useTranslation } from "react-i18next";
import FooterLanguageChange from "./FooterLanguageChange";
import FooterCurrencyChange from "./FooterCurrencyChange";
import { Link } from "react-router-dom";
import { ResponseMessages } from "../../domain/enums/common/ResponseMessagesEnum";
import { easypayLink, mastercardLink, projectEmail, prostirLink, visaLink } from "../../Config";
import useToastMessage from "../../custom-hooks/useToastMessage";
import ProstirLogoSVG from "../resources/svg/logos/ProstirLogoSVG";
import EasyPayLogoSVG from "../resources/svg/logos/EasyPayLogoSVG";
import MasterCardLogoSVG from "../resources/svg/logos/MasterCardLogoSVG";
import VisaLogoSVG from "../resources/svg/logos/VisaLogoSVG";
import CustomToast from "../../custom-components/CustomToast";
import { DocumentsSections } from "../../domain/enums/DocumentsSectionsEnum";

const Footer: FC = () => {
    const { t } = useTranslation();
    const { message, setMessage, resetMessage } = useToastMessage();
    const copyProjectEmailHandler = async () => {
        await navigator.clipboard.writeText(projectEmail);
        setMessage("messages.copied", ResponseMessages.SUCCESS);
    };

    return (
        <footer className="relative h-[414px] bg-[rgb(0_0_0_/_15%)] mt-auto">
            <div className="absolute flex flex-col justify-center items-center left-0 right-0 mx-auto h-full">
                <div className="flex tmax4:flex-col justify-center items-center mb-8">
                    <FooterLanguageChange />
                    <FooterCurrencyChange />
                </div>
                <div className="flex flex-col items-center">
                    <div className="mb-6 tmax4:mb-5 td4:mb-5">
                        <Link
                            to="/contacts"
                            className="H16 tmax4:H14 text-textFaded hover:text-textWhite mr-9 tmax4:mr-5 transition-all duration-300"
                        >
                            {t("common.contacts")}
                        </Link>
                        <Link
                            to="/catalog"
                            className="H16 tmax4:H14 text-textFaded hover:text-textWhite mr-9 tmax4:mr-5 transition-all duration-300"
                        >
                            {t("common.catalog")}
                        </Link>
                        <Link
                            to="/"
                            className="H16 tmax4:H14 text-textFaded hover:text-textWhite transition-all duration-300"
                        >
                            {t("common.main")}
                        </Link>
                    </div>
                    <div className="flex tmax4:flex-col">
                        <div>
                            <Link
                                to="/documents"
                                className="H16 tmax4:H14 text-textFaded hover:text-textWhite underline mr-9 tmax4:mr-5 transition-all duration-300"
                            >
                                {t(`documentsSections.${DocumentsSections.USER_AGREEMENT}`)}
                            </Link>
                            <Link
                                to="/documents"
                                className="H16 tmax4:H14 text-textFaded hover:text-textWhite underline mr-9 tmax4:mr-0 transition-all duration-300"
                            >
                                {t("common.documents")}
                            </Link>
                        </div>
                        <div
                            onClick={copyProjectEmailHandler}
                            className="relative H16 tmax4:H14 flex justify-center text-textFaded hover:text-textWhite tmax4:mt-5 cursor-pointer transition-all duration-300"
                        >
                            {projectEmail}
                            <CustomToast
                                messageObj={message}
                                resetMessageObj={resetMessage}
                                wrapClassName="flex items-center bg-backgroundInput h-[25px] rounded-[10px] px-3"
                                labelClassName="H16 text-textWhite text-nowrap"
                                staticClassName="top-[25px]"
                                staticType
                                singleMessageMode
                            />
                        </div>
                    </div>
                </div>
                <div className="flex justify-center items-center h-[50px] mt-[52px] tmax4:mt-8">
                    <a href={prostirLink} target="_blank" rel="noreferrer">
                        <ProstirLogoSVG className="tmax4:w-[71px] mr-[115px] td4:mr-[55px] tmax4:mr-[39px]" />
                    </a>
                    <a href={easypayLink} target="_blank" rel="noreferrer">
                        <EasyPayLogoSVG className="tmax4:w-[68px] mr-[115px] td4:mr-[55px] tmax4:mr-[39px]" />
                    </a>
                    <a href={mastercardLink} target="_blank" rel="noreferrer">
                        <MasterCardLogoSVG className="tmax4:w-[39px] mr-[115px] td4:mr-[55px] tmax4:mr-[39px]" />
                    </a>
                    <a href={visaLink} target="_blank" rel="noreferrer">
                        <VisaLogoSVG className="tmax4:w-[55px]" />
                    </a>
                </div>
                <div className="H16 td4:H14 tmax4:H12 text-textFaded mt-6 tmax4:mt-5">{t("common.copyright")}</div>
            </div>
        </footer>
    );
};

export default Footer;
